
 <div *ngIf="type === 'table'" class="row">
 
        <div class="col col-sm-12">
        <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: height }"  appearance="circle"></ngx-skeleton-loader>
  
	</div>
 </div>



<div *ngIf="type === 'channel'">
<div class="row">

    <div class="col-xs-12 col-lg-6">

        <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '260px', 'margin-bottom': '1.875rem' }"  appearance="circle"></ngx-skeleton-loader>
    </div>

    <div class="col-xs-12 col-lg-3">
        
        <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '260px', 'margin-bottom': '1.875rem'  }"  appearance="circle"></ngx-skeleton-loader>
    </div>

    <div class="col-xs-12 col-lg-3">
         
        <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '260px', 'margin-bottom': '1.875rem'  }"  appearance="circle"></ngx-skeleton-loader>
    </div>


</div>


<div class="row">

    <div class="col-xs-12 col-md-6">
         
        <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '331px', 'margin-bottom': '1.875rem'  }"  appearance="circle"></ngx-skeleton-loader>
    </div>

    <div class="col-xs-12 col-md-3">
       
        <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '331px', 'margin-bottom': '1.875rem'  }"  appearance="circle"></ngx-skeleton-loader>
    </div>

    <div class="col-xs-12 col-md-3">
       
        <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '275px', 'margin-bottom': '1.875rem'  }"  appearance="circle"></ngx-skeleton-loader>
    </div>


</div>


<div class="row">

    <div class="col-xs-12 col-md-6">
         
        <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '72px', 'margin-bottom': '1.875rem'  }"  appearance="circle"></ngx-skeleton-loader>
 
  </div>


</div>


<div class="row">

    <div class="col-xs-12 col-md-6">
        
        <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '52px', 'margin-bottom': '1.875rem'  }"  appearance="circle"></ngx-skeleton-loader>
  </div>


</div>

 <div class="row" style="min-height:80px;">
     <div class="col-12">
<div style="position:fixed; right:20px; bottom:-10px;">

        <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '74px' }"  appearance="circle"></ngx-skeleton-loader>
 </div>
     </div>
 </div>
 
</div>




<div *ngIf="type === 'stream'" >
	<div class="row">
		<div class="col-12">
			     <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '23px', 'max-width':'200px', 'margin-bottom': '18px'  }"  appearance="circle"></ngx-skeleton-loader>
	 
		</div>

	</div>

    <div class="row">

	    <div class="col-xs-12 col-md-7" >

        <ngx-skeleton-loader *ngFor="let item of streamsLeft" [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: item, 'margin-bottom': '1rem'  }"  appearance="circle"></ngx-skeleton-loader>

 

	    </div>

	<div style="position: relative; z-index: 7;"  class="col-xs-12 col-md-5">

			<div class="rightPanels" >
        <ngx-skeleton-loader *ngFor="let item of streamsRight" [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: item, 'margin-bottom': '1rem'  }"  appearance="circle"></ngx-skeleton-loader>

 

	    </div> 

    </div>

 </div>
</div>


<div *ngIf="type === 'video'" >
	<div class="row">
		<div class="col-12">
			     <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '23px', 'max-width':'200px', 'margin-bottom': '18px'  }"  appearance="circle"></ngx-skeleton-loader>
	 
		</div>

	</div>

    <div class="row">

	    <div class="col-xs-12 col-md-7" >

        <ngx-skeleton-loader *ngFor="let item of videosLeft" [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: item, 'margin-bottom': '1rem'  }"  appearance="circle"></ngx-skeleton-loader>

 

	    </div>

	<div style="position: relative; z-index: 7;"  class="col-xs-12 col-md-5">

			<div class="rightPanels" >
        <ngx-skeleton-loader *ngFor="let item of videosRight" [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: item, 'margin-bottom': '1rem'  }"  appearance="circle"></ngx-skeleton-loader>

 

	    </div> 

    </div>

 </div>
</div>




<div  *ngIf="type === 'inner-stat'" class="row">
	<div class="col-12">

<div class="row">
<div class="col-12">
		<div class="topPanel">
			<div><div  class="item"> <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '23px', 'max-width':'200px'  }"  appearance="circle"></ngx-skeleton-loader></div></div>
		</div>
</div>

</div>

<div class="row">
<div class="col-12">
		 <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '23px', 'max-width':'200px', 'margin-bottom': '18px'  }"  appearance="circle"></ngx-skeleton-loader>
	 
</div>

</div>
 		

		<div class="row">
			<div class="col-12 col-sm-6 col-md-6 col-md-6 col-lg-3 statColumn">

			 <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '132px', 'margin-bottom': '18px'  }"  appearance="circle"></ngx-skeleton-loader>
		</div>
			<div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">

			 <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '132px',  'margin-bottom': '18px'  }"  appearance="circle"></ngx-skeleton-loader>

			</div>

			 <div class="col-12  col-md-12 col-lg-6 statColumn">

  <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '132px',  'margin-bottom': '18px'  }"  appearance="circle"></ngx-skeleton-loader>

			</div>
		</div> 

<div class="row">
			<div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">

			 
  <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '202px',  'margin-bottom': '18px'  }"  appearance="circle"></ngx-skeleton-loader>
		</div>
			<div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">
 
  <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '202px',  'margin-bottom': '18px'  }"  appearance="circle"></ngx-skeleton-loader>

			</div>

			 <div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">
 				
 
  <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '202px',  'margin-bottom': '18px'  }"  appearance="circle"></ngx-skeleton-loader>
			</div>
 
			

			 <div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">
 				
			 
  <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '202px',  'margin-bottom': '18px'  }"  appearance="circle"></ngx-skeleton-loader>

			</div>




		</div> 



		<div class="row">

			 <div class="col-12 col-md-6 col-lg-6 statColumn">
			 
			 
  <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '264px',  'margin-bottom': '18px'  }"  appearance="circle"></ngx-skeleton-loader>


			</div>
		

			 <div class="col-12  col-md-6  col-lg-6 statColumn">
			 
			 
  <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '264px',  'margin-bottom': '18px'  }"  appearance="circle"></ngx-skeleton-loader>


			</div>


		</div>

 
	</div>

</div>






<div *ngIf="type === 'playlists'" >
	<div class="row">
		<div class="col-12">
			     <ngx-skeleton-loader [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: '32px', 'max-width':'200px', 'margin-bottom': '18px'  }"  appearance="circle"></ngx-skeleton-loader>
	 
		</div>

	</div>

    <div class="row">

	    <div class="col-xs-12 col-md-7" >

        <ngx-skeleton-loader *ngFor="let item of playlistLeft" [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: item, 'margin-bottom': '1rem'  }"  appearance="circle"></ngx-skeleton-loader>

 

	    </div>

	<div style="position: relative; z-index: 7;"  class="col-xs-12 col-md-5">

			<div class="rightPanels" >
        <ngx-skeleton-loader *ngFor="let item of playlistRight" [theme]="{'position':'relative', 'margin':0, width: '100%',   'border-radius': '0px', height: item, 'margin-bottom': '1rem'  }"  appearance="circle"></ngx-skeleton-loader>

 

	    </div> 

    </div>

 </div>
</div>




